import { styled } from '../../../utils/styled'
import Grid from '../../Grid'

export const StyledGridMessageListContainer = styled(Grid)(() => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '16px',
  paddingBottom: '16px'
}))

/** Wrapper for each date group so gap is applied between MessageCards (including SystemEvent) within the group */
export const StyledGridDateGroup = styled(Grid)(() => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '16px'
}))

/** Fills remaining viewport below the pinned user message so it can sit at the top. */
export const StyledMessageListScrollSpacer = styled('div')(() => ({
  flexShrink: 0,
  width: '100%',
  pointerEvents: 'none'
}))
